import { render, staticRenderFns } from "./list_approval.vue?vue&type=template&id=76239815&scoped=true"
import script from "./list_approval.vue?vue&type=script&lang=js"
export * from "./list_approval.vue?vue&type=script&lang=js"
import style0 from "./list_approval.vue?vue&type=style&index=0&id=76239815&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76239815",
  null
  
)

export default component.exports